<template>
  <!-- <a-config-provider :locale="zh_CN">
    <div id="app">
      <router-view></router-view>
    </div>
  </a-config-provider> -->
  <router-view />
</template>

<script>
// import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";  ant-design-vue 汉化
export default {
  name: "App",
  // data() {
  //   return {
  //     zh_CN
  //   };
  // }
};
</script>



// WEBPACK FOOTER //
// src/App.vue